import React from "react";
import { Button, Card, Carousel, Col, Container, Form, Image, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { SliderPicker } from 'react-color';
import { setAvatarInDB, setUserSettingsInDB } from "./../../actions";
import avatars from "./../../images/avatars";
import "./UserProfile.css";
import VerticallyCenteredModal from "./../Modal/VerticallyCenteredModal";
import JumpNumberTransition from "./../TextTransition/JumpNumberTransition";
import WobblyTextTransition from "./../TextTransition/WobblyTextTransition";


class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      avatarId: null,
      showChangeAvatarModal: false,
      showColorPicker: false,
      showChangeNameForm: false,
      avatarBackground: null,
      avatarBorderColor: null,
      userName:""
    } ;
  }

  /**
   * Show user collected pictures
   */
  showCollectedPictures = () => {
    return (Object.keys(this.props.gainedAvatars).map((value, index)=>{
      return (
        <Carousel.Item key={value}>
          <img
            id={value}
            style={{height: "200px"}}
            className="d-block mx-auto"
            src={avatars[value]} 
            alt="First slide"
            onClick={(e)=>{this.setState({avatarId: e.target.id})}}
          />
        </Carousel.Item>
      );
    }));
  }

  /**
   * Update user profile avatar in the database.
   */
  updateUserAvatarInDB = () => {
    this.state.avatarId&&this.props.setAvatarInDB(this.state.avatarId);
    this.setState({showChangeAvatarModal: false});
  }

  updateUserNameInDB = (event) => {
    event.preventDefault();
    const userName = this.state.userName.trim();
    console.log(userName);

    if (userName && userName.length>0) {
      this.props.setUserSettingsInDB({ userName });
    }
    this.setState({showChangeNameForm: false});
  }

  /**
   * update avatar background color and border color
   */
  updateAvatarColorsInDB = () => {
    const avatarBackground = this.state.avatarBackground ? this.state.avatarBackground : this.props.avatarBackground;
    const avatarBorderColor = this.state.avatarBorderColor ? this.state.avatarBorderColor : this.props.avatarBorderColor;
    if (avatarBackground && avatarBorderColor) {
      this.props.setUserSettingsInDB({ avatarBackground, avatarBorderColor });
    }
    this.setState({showColorPicker: false});
  }

  render() {
    return (
      <div id={this.props.background} className="userProfile">
        <Container 
          style={{
            padding: "1rem", 
            paddingBottom: "30vh", 
            fontFamily: "'Hachi Maru Pop', cursive",
            fontWeight: "bold",
            fontSize: "130%"
          }} 
          fluid
        >
          <VerticallyCenteredModal
            show={this.state.showChangeAvatarModal}
            onHide={()=>{this.setState({showChangeAvatarModal: false})}}
            onSubmit={this.props.coins >= 100? this.updateUserAvatarInDB : null}
            message={this.props.coins >= 100? modalMessages.changeAvatarMessage : modalMessages.changeAvatarNotAllowMessage}
            title={this.props.coins >= 100? modalMessages.changeAvatarTitle : modalMessages.changeAvatarNotAllowTitle}
          />
          <Row style={{paddingLeft:"1rem"}}>
            <Card>
              <Container style={{padding: "5px"}}>
                <Image 
                  src={avatars[this.state.avatarId? this.state.avatarId : this.props.avatarId]} 
                  style={{
                    height: "300px",
                    borderColor: this.state.avatarBorderColor? this.state.avatarBorderColor: this.props.avatarBorderColor,
                    backgroundColor: this.state.avatarBackground? this.state.avatarBackground: this.props.avatarBackground,
                    borderWidth: "9px"
                  }}
                  thumbnail
                />
                {
                  !this.state.showColorPicker &&
                  <h2
                    className="text-primary" 
                    style={{
                      position:"absolute",
                      bottom:"10px",
                      right:"30px"
                    }}
                    onClick={()=>{this.setState({showColorPicker: true})}}
                  >
                    <i className="fas fa-sliders-h"></i>
                  </h2>
                }
                {
                  this.state.avatarId && this.state.avatarId !== this.props.avatarId && !this.state.showColorPicker &&
                  <h2
                    style={{
                      position:"absolute",
                      bottom:"0px",
                      left:"20px"
                    }}
                  >
                    <i className="fas fa-check-circle text-success"
                      onClick={()=>{this.setState({showChangeAvatarModal: true})}}
                    />
                    <i 
                      className="fas fa-times-circle text-danger"
                      onClick={()=>{this.setState({avatarId: null})}}
                    />
                  </h2>
                }
              </Container>
              {
                this.state.showColorPicker &&
                <Container>
                  <FormattedMessage id="userprofile.background_color" defaultMessage="Background" />
                   <SliderPicker
                    color={this.state.avatarBackground? this.state.avatarBackground: this.props.avatarBackground}
                    onChange={(color)=>{this.setState({avatarBackground: color.hex})}}
                   />
                </Container>
              }
              {
                this.state.showColorPicker &&
                <Container style={{paddingBottom: "30px"}}>
                  <FormattedMessage id="userprofile.border_color" defaultMessage="Border" />
                  <SliderPicker
                    color={this.state.avatarBorderColor? this.state.avatarBorderColor: this.props.avatarBorderColor}
                    onChange={(color)=>{this.setState({avatarBorderColor: color.hex})}}
                  />
                </Container>
              }
              {
                this.state.showColorPicker && 
                <div
                  style={{position: "absolute", bottom: "0px", right: "20px"}}
                >
                  <i className="fas fa-check-circle text-success" 
                    onClick={this.updateAvatarColorsInDB}
                  />
                  <i className="fas fa-times-circle text-danger"
                    onClick={()=>{this.setState({showColorPicker: false, avatarBackground: null, avatarBorderColor: null})}}
                  />
                </div>
              }
            </Card>
            <Col 
              sm={4}
              lg={6}
              style={{
                paddingLeft:"1.5rem"
              }}
            >
              <p>
                <FormattedMessage id="userprofile.name" defaultMessage="User Name" />: <WobblyTextTransition value={this.props.preferredName} />&nbsp; 
                { 
                  !this.state.showChangeNameForm && 
                  <i className="fa fa-cog text-primary" onClick={()=>{this.setState({showChangeNameForm: true})}} />
                }
                {
                  this.state.showChangeNameForm &&
                  <Form onSubmit={this.updateUserNameInDB}>
                    <Form.Row>
                      <Col>
                        <Form.Control
                          value={this.state.userName}
                          onChange={(e)=>{this.setState({userName: e.target.value})}}
                        />
                      </Col>
                      <Col>
                        <Button type="submit">OK</Button>
                      </Col>
                    </Form.Row>
                  </Form>
                }
              </p>
              <p><FormattedMessage id="userprofile.level" defaultMessage="Level" />: <span className="text-warning"><JumpNumberTransition value={Math.ceil(this.props.experience/100)} /></span> </p>
              <p><FormattedMessage id="userprofile.exp" defaultMessage="Experiences" />: <span className="text-warning"><JumpNumberTransition  value={this.props.experience} /></span> </p>
              <p><FormattedMessage id="userprofile.coins" defaultMessage="Stars" /> <i className="far fa-star text-warning"/><i className="fas fa-star text-warning"/>: <span className="text-warning"><JumpNumberTransition value={this.props.coins} /></span></p>
              <p><FormattedMessage id="userprofile.keys" defaultMessage="Keys" />: <span className="text-warning"><JumpNumberTransition value={this.props.keys} /></span> </p>
            </Col>
            <Col sm={4} lg={2} style={{float: "right"}}>
              <p className="text-primary"><FormattedMessage id="userprofile.mypictures" defaultMessage="My Pictures " /> <Link to="#123"><i className="far fa-images"></i></Link></p>
              <Carousel style={{width: "300px"}}>
                {this.showCollectedPictures()}
              </Carousel>
            </Col>
          </Row>
          <hr />
          <Container fluid style={{fontWeight: "normal", fontSize: "80%"}}>
            <p style={{fontWeight: "bold", fontSize: "150%"}}><FormattedMessage id="userprofile.membership" defaultMessage="Membership" /></p>
            <p><FormattedMessage id="userprofile.mathmembership" defaultMessage="Math Membership expires on" /> {(new Date(this.props.mathMembershipExpire)).toLocaleString()}</p>
            <p><FormattedMessage id="userprofile.chinesemembership" defaultMessage="Chinese Membership expires on" /> {(new Date(this.props.hanziMembershipExpire)).toLocaleString()}</p>
            <p><FormattedMessage id="userprofile.addsfree" defaultMessage="Adds free expires on" /> {(new Date(this.props.adsFreeExpire)).toLocaleString()}</p>
          </Container>
          <Row>   
          </Row>
        </Container>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    ...state.userSettings,
    ...state.userRecords,
    ...state.user,
    preferredName: state.userSettings.userName
  };
}

const modalMessages = {
  changeAvatarTitle: <FormattedMessage id="changeAvatar.title" defaultMessage="Change Your Profile Picture"/>,
  changeAvatarMessage: <FormattedMessage id="changeAvatar.message" defaultMessage="Permanently change your profile picture will cost 100 stars. Are you sure to do that?"/>,
  changeAvatarNotAllowTitle: <FormattedMessage id="notAllowed.title" defaultMessage="Not Allowed"/>,
  changeAvatarNotAllowMessage: <FormattedMessage id="changeAvatar.message.not.allowed" defaultMessage="Permanently change your profile picture will cost 100 stars. You don't have enough stars to change your profile picture. "/>
}

export default connect(mapStateToProps, { setAvatarInDB, setUserSettingsInDB })(UserProfile);